import React from "react";
import { Hooks } from "@xt/xtbase";
import styles from "./ConvertBuy/index.module.less";

const { useTranslation } = Hooks;

const SWAP_ICON = require("./assets/convert-swap-btn.svg").default;

export default function ConvertSwapDirectionBtn({ onClick }) {
  const t = useTranslation();
  const isInteractive = typeof onClick === "function";

  if (!isInteractive) {
    return (
      <div className={`${styles["convert-buy__swap-btn"]} ${styles["convert-buy__swap-btn--static"]}`} aria-hidden="true">
        <img src={SWAP_ICON} alt="" width={36} height={36} draggable={false} />
      </div>
    );
  }

  return (
    <button
      type="button"
      className={styles["convert-buy__swap-btn"]}
      onClick={onClick}
      aria-label={t("convert.swapDirection")}
    >
      <img src={SWAP_ICON} alt="" width={36} height={36} draggable={false} />
    </button>
  );
}
